import { useTranslation } from "react-i18next";
import type { Route } from "./+types/about";
import { Container } from "~/components/layout/Container";
import { PageHeader } from "~/components/layout/PageHeader";
import { FeatureCard } from "~/components/common/FeatureCard";
import { ButtonAnchor } from "~/components/common/Button";
import {
  BuildingIcon,
  CheckCircleIcon,
  LockIcon,
} from "~/components/common/icons";

export function headers() {
  return {
    "Cache-Control":
      "public, max-age=0, s-maxage=300, stale-while-revalidate=60",
  };
}

export const meta: Route.MetaFunction = () => [
  { title: "About | Raytio Trust Marketplace" },
  {
    name: "description",
    content: "Learn how the Raytio Trust Marketplace works.",
  },
];

export default function AboutRoute() {
  const { t } = useTranslation();

  const steps = [
    {
      icon: <LockIcon className="h-6 w-6" />,
      title: t("AboutPage.step-1-title"),
      description: t("AboutPage.step-1-desc"),
    },
    {
      icon: <BuildingIcon className="h-6 w-6" />,
      title: t("AboutPage.step-2-title"),
      description: t("AboutPage.step-2-desc"),
    },
    {
      icon: <CheckCircleIcon className="h-6 w-6" />,
      title: t("AboutPage.step-3-title"),
      description: t("AboutPage.step-3-desc"),
    },
  ];

  return (
    <>
      <PageHeader
        eyebrow={t("AboutPage.eyebrow")}
        title={t("AboutPage.hero-title")}
        subtitle={t("AboutPage.hero-subtitle")}
        centered
      />

      {/* Body */}
      <section className="py-16">
        <Container>
          <div className="mx-auto max-w-3xl space-y-16">
            {/* What is */}
            <div>
              <h2 className="font-heading text-2xl font-bold text-text-full">
                {t("AboutPage.what-is-title")}
              </h2>
              <div className="mt-4 space-y-4 text-text-medium">
                <p>{t("AboutPage.what-is-p1")}</p>
                <p>{t("AboutPage.what-is-p2")}</p>
              </div>
            </div>

            {/* How verification works */}
            <div>
              <h2 className="font-heading text-2xl font-bold text-text-full">
                {t("AboutPage.how-title")}
              </h2>
              <div className="mt-6 grid gap-6 md:grid-cols-3">
                {steps.map(step => (
                  <FeatureCard
                    key={step.title}
                    icon={step.icon}
                    title={step.title}
                    description={step.description}
                  />
                ))}
              </div>
            </div>

            {/* Get listed */}
            <div>
              <h2 className="font-heading text-2xl font-bold text-text-full">
                {t("AboutPage.get-listed-title")}
              </h2>
              <p className="mt-4 text-text-medium">
                {t("AboutPage.get-listed-body")}
              </p>
              <ButtonAnchor
                href="https://www.rayt.io"
                target="_blank"
                rel="noopener noreferrer"
                variant="primary"
                className="mt-6"
              >
                {t("AboutPage.get-listed-button")}
              </ButtonAnchor>
              <p className="mt-3 text-sm text-text-light">
                {t("AboutPage.get-listed-helper")}
              </p>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
}
